/**
 * i18n — zh-HK（主）／en／zh-CN（`decisions/005`；`ui-spec.md` §5）
 * ⚠️ 三個語言檔要**逐 key 對齊**（P1-6 起用 `@coeldery/parity-guard` 守衛）。
 */
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import zhHK from './locales/zh-HK.json';
import en from './locales/en.json';
import zhCN from './locales/zh-CN.json';

export const LANGS = ['zh-HK', 'en', 'zh-CN'] as const;

void i18n.use(initReactI18next).init({
  resources: {
    'zh-HK': { translation: zhHK },
    en: { translation: en },
    'zh-CN': { translation: zhCN },
  },
  lng: 'zh-HK',
  fallbackLng: 'zh-HK',
  interpolation: { escapeValue: false },
});

export default i18n;
